import React, { FC, useState, useEffect } from 'react';
import { Box, Switch, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { OmnichannelQuery } from '../../../../services/query';
import { OmnichannelCommand } from '../../../../services/command';
import Swal from 'sweetalert2';
import { SM_OCS } from './omniChannelService.classes';

export const OmniChannelService: FC = () => {
    const { t } = useTranslation();
    const [serviceManagementValue, setServiceManagementValue] = useState(false);

    const getServiceManagment = () => {
        OmnichannelQuery.ServiceManagment()
            .then((res: any) => {
                if (res) {
                    setServiceManagementValue(res.data.status === 1);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };

    const handleUserActivityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        Swal.fire({
            text: t('authorizationManagement.listUser.surePassiveText'),
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('general.update'),
        }).then((result: any) => {
            if (result.isConfirmed) {
                let params: any = {};
                params.newstatus = !event.target.checked === true ? 1 : 0;
                OmnichannelCommand.PostServiceManagment(params)
                    .then(() => {
                        Swal.fire(t('general.updated'), ' ', 'success');
                    })
                    .catch((error: any) => {
                        console.log('Hata :>> ', error);
                    });
            }
        });
    };

    useEffect(() => {
        getServiceManagment();
    }, []);

    return (
        <Box
            sx={{
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
                bgcolor: 'background.paper',
                px: 3,
                py: 1,
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                maxWidth: 560,
                width: '100%',
            }}
            className={SM_OCS.card}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', minHeight: 52 }} className={SM_OCS.row}>
                <Typography variant="body2" fontWeight={600} sx={{ flex: 1 }} className={SM_OCS.title}>
                    OmniChannel Service
                </Typography>
                <Switch
                    checked={serviceManagementValue}
                    onChange={handleUserActivityChange}
                    className={SM_OCS.toggle}
                />
            </Box>
        </Box>
    );
};
